import { makeStylesheetLink } from "@self/stylesheet";
import { udpdateReview, validateBillingForm } from "@self/utils";

export class ReviewOrderButton extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" className="gct-btn-lg gct-w100">Review order</button> as HTMLButtonElement;
		this.onClick = onClick.bind(this);

		this.shadow.append(this.button, makeStylesheetLink());
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: ReviewOrderButton) {
	try {
		this.button.disabled = true;

		if (!validateBillingForm()) return;

		udpdateReview();

		const paymentTab = document.getElementById("panel-payment");
		const reviewOrderTab = document.getElementById("panel-review");

		if (paymentTab) paymentTab.classList.add("gct-d-none");
		if (reviewOrderTab) reviewOrderTab.classList.remove("gct-d-none");

		const reviewFormLink = document.getElementById("btn-review");
		if (reviewFormLink) {
			reviewFormLink.classList.remove("gct-checkout-tab-disabled");
			reviewFormLink.classList.add("gct-checkout-tab");
		}

		const paymentFormLink = document.getElementById("btn-payment");
		if (paymentFormLink) {
			paymentFormLink.classList.remove("gct-checkout-tab");
		}

		window.scrollTo(0, 0);
	} finally {
		this.button.disabled = false;
	}
}
